import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor } from '@angular/common';
import { Subject, debounceTime } from 'rxjs';

import { TaggingService } from '../../../../Services/Tagging/tagging.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-staff-direct-issue',
  standalone: true,
  imports: [FormsModule, NgIf, NgFor],
  templateUrl: './direct-issue.component.html',
})
export class DirectIssueComponent implements OnInit {

  staffId!: number;
  barcode = '';
  suggestions: any[] = [];

  private barcode$ = new Subject<string>();

  constructor(
    private route: ActivatedRoute,
    private taggingService: TaggingService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService
  ) {}

  ngOnInit(): void {
    // get staffId
    this.route.parent?.paramMap.subscribe(params => {
      this.staffId = Number(params.get('staffId'));
    });

    // debounce barcode input (scanner safe)
    this.barcode$
      .pipe(debounceTime(250))
      .subscribe(code => this.searchBarcode(code));
  }

  onBarcodeInput() {
    this.barcode$.next(this.barcode.trim());
  }

  private searchBarcode(code: string) {
    if (!code) {
      this.suggestions = [];
      return;
    }

    const firm = this.firmSelectionService.getselectedFirmName();
    if (!firm?.id) return;

    const params = new HttpParams()
      .set('std_firm_id', firm.id)
      .set('barcode', code);

    this.taggingService.getTaggings(params).subscribe((res: any) => {
      const matches = (res.data || []).filter(
        (t: any) => !t.issued_stock_id
      );

      this.suggestions = matches;

      // 🔥 AUTO ISSUE if exactly ONE match
      // if (matches.length === 1) {
      //   this.issueStock(matches[0]);
      // }

    
      if (matches.length === 0) {
        this.errorBeep();
      }
    });
  }

onScanComplete() {
  const code = this.barcode.trim().toUpperCase();
  if (!code) return;

  const firm = this.firmSelectionService.getselectedFirmName();
  if (!firm?.id) return;

  this.taggingService.scanBarcode(firm.id, code).subscribe({
    next: (res) => {
      const tag = res?.data;

      if (!tag) {
        this.errorBeep();
        this.notificationService.showError('No stock found', 'Error');
        this.reset();
        return;
      }

      // ✅ AUTO ISSUE
      this.issueStock(tag);
    },
    error: () => {
      this.errorBeep();
      this.notificationService.showError('Invalid barcode', 'Error');
    }
  });
}


  private issueStock(tag: any) {
  const payload = { issued_stock_id: this.staffId };

  this.taggingService.updateStockIssue(tag.std_id, payload).subscribe({
    next: () => {
      this.successBeep();
      this.notificationService.showSuccess(
        `Issued: ${tag.std_barcode}`,
        'Success'
      );
      this.reset();
    },
    error: () => {
      this.errorBeep();
      this.notificationService.showError('Failed to issue stock', 'Error');
    }
  });
}


  private reset() {
    this.barcode = '';
    this.suggestions = [];
  }

  // 🔊 Sounds
  private successBeep() {
    new Audio('/assets/sounds/success.mp3').play();
  }

  private errorBeep() {
    new Audio('/assets/sounds/error.mp3').play();
  }
}
